export interface LenderAccountInfo {
    lenderId: string;
    principalOutstanding: number;
    interestAmount: number;
    withdrawalAmount: number;
    roi: number;
    maxNCashAmount: number;
    nCashAmount: number;
    nCashDate: string;
    withdrawBackMoney: number;
    products: LenderProductAccountInfo[];
}

export interface LenderProductAccountInfo {
    productCode: string;
    principalOutstanding: number;
    interestAmount: number;
    withdrawalAmount: number;
    roi: number;
    creditLossAmount: number;
    investmentAmount: number;
    mhp: number;
    nCashAmount: number;
    withdrawBackMoney: number;
    interestVariant?: LenderProductCategoryVariant,
    principalOutstandingVariant?: LenderProductCategoryVariant,
    roiVariant?: LenderProductCategoryVariant
}

export enum DASHBOARD_LENDER_ATTRIBUTES {
    EXPANDED_ROI = "expandRoi",
    EXPANDED_PRINCIPLE_OUTSTANDING = "expandPrincipalOutstanding",
    EXPANDED_INTEREST_EARNED = "expandInterestEarned"
}

export enum INTEREST_RATE_PRODUCT_VARIANT {
    F6,
    F6_C1,
    F6_C2,
    F12,
    F12_C1,
    F12_C2,
    F24,
    F24_C1,
    F24_C2,
    F36,
    F36_C1,
    F36_C2
}

export interface LenderProductCategoryVariant {
    [key: string]: INTEREST_RATE_PRODUCT_VARIANT | number;
}
